import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        padding: '10px 0', 
        marginBottom: 12, 
        width: '100%', 
        background: '#1b2039', 
        borderRadius: 8, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        flexDirection: 'column'
    },
    block: {
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center'
    },
    helper: {
        color: 'hsla(0,0%,100%,.5)',
        fontSize: 16,
        width: 150,
        fontFamily: 'PT-sans, sans-serif',
    },
    description: {
        color: '#fff',
        fontSize: 16,
        fontFamily: 'PT-sans, sans-serif',  
    }
}))

export {
    useStyles
}